export default __webpack_public_path__ + "static/media/screen_webchat_2.d6d14c36.png";